<template>
  <div class="history">
    <history-filter v-if="showFilter === true" @close = "showFilter = false" @filterSelect='setData' />
    <div class="title">
      <span>تاریخچه</span>
    </div>
    <div class="table">
      <div class="buttons">
        <div class="left-row">
          <button @click="trade" :class="{'gray-btn': select === 'trade' , 'solid-gray-btn' : select !== 'trade' }" >معاملات</button>
          <button @click="order" :class="{'gray-btn': select === 'order' , 'solid-gray-btn' : select !== 'order' }">سفارشات</button>
          <button @click="usdtTR"  :class="{'gray-btn': select === 'usdtTR' , 'solid-gray-btn' : select !== 'usdtTR' }">تراکنش ارزی</button>
          <button @click="rialTR" :class="{'gray-btn': select === 'rialTR' , 'solid-gray-btn' : select !== 'rialTR' }">تراکنش ریالی</button>
          <button @click="loginhistory" :class="{'gray-btn': select === 'loginhistory' , 'solid-gray-btn' : select !== 'loginhistory' }">لاگین</button>
        </div>
        <div class="right-row" v-if=" select === 'trade' ||select === 'order' ||select === 'usdtTR' ">
          <button @click="type = 'crypto'"  :class="{'gray-btn': type === 'crypto' , 'solid-gray-btn' : type !== 'crypto' }">رمز ارز</button>
          <button @click="type = 'gold'"  :class="{'gray-btn': type === 'gold' , 'solid-gray-btn' : type !== 'gold' }">طلا و سکه</button>
        </div>
      </div>
      <div @click="showFilter = true" @filterSelect='value=> query = value' class="filter" v-if="select !== 'rialTR' && select !== 'loginhistory'" >
        <inline-svg :src="require('../../../../assets/icon/filter.svg')"/>
        <span class="filterspan">فیلتر</span>
      </div>
      <div class="tables">
        <trade-history v-if="select === 'trade'" :query='query'/>
        <order-history v-if="select === 'order'" :query='query' />
        <usdt-tr-history v-if="select === 'usdtTR'"  :query='query'/>
        <rial-t-r-history v-if="select === 'rialTR'"/>
        <login-history v-if="select === 'loginhistory'"/>
      </div>
    </div>
  </div>
</template>


<script>

import TradeHistory from "./tradeHistory";
import OrderHistory from "./orderHistory";
import UsdtTrHistory from "./usdtTrHistory";
import RialTRHistory from "./rialTRHistory";
import LoginHistory from "./loginHistory";
import HistoryFilter from "./historyFilter";
export default {
  name: "history",
  components: {HistoryFilter, LoginHistory, RialTRHistory, UsdtTrHistory, OrderHistory, TradeHistory},
  data(){
    return {
      select: 'trade',
      type: '',
      showFilter:false,
   query:Object,

    }
  },

  methods: {

async setData(value){
this.query = value
// console.log(this.query)
this.$store.commit('setQuery' , value);
// console.log(this.$store.state.query)
},

    

    trade() {
      this.select = 'trade';
      console.log('trade', this.select)
    },
    order() {
      this.select = 'order';
      console.log('trade', this.select)
    },
    usdtTR() {
      this.select = 'usdtTR';
      console.log('trade', this.select)
    },
    rialTR() {
      this.select = 'rialTR';
      console.log('trade', this.select)
    },
    loginhistory() {
      this.select = 'loginhistory';
      console.log('trade', this.select)
    }

  }
}
</script>

<style lang="scss" scoped>
.panel-box {
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(40px);
  border-radius: 20px;
  padding: 35px;
}

.history {


  .title {
    display: flex;
    justify-content: flex-start;
    margin: 40px 0;

    span {
      color: #FFFFFF;
      font-size: clamp(16px, 2vw, 22px);
    }
  }

  .table {
    @extend .panel-box;
    display: flex;
    flex-direction: column;
    gap: 27px;

    table {
      table-layout: fixed;

      .header-tr {
        height: 75px;
      }

      th {
        font-size: 14px;
        color: #D7C8C8;
      }

      td {
        font-size: 14px;
        color: #D7C8C8;

        span {
          display: ruby;
        }
      }
    }

    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 30px;

      .left-row {
        display: flex;
        justify-content: flex-start;
        gap: 10px;
        flex-wrap: wrap;

        button {
          width: 144px;
          height: 25px;
        }
      }

      .right-row {
        display: flex;
        flex-direction: row;
        gap: 10px;
        justify-content: flex-end;
        flex-wrap: wrap;

        button {
          width: 107px;
          height: 25px;
        }
      }
    }

    .filter {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      gap: 6px;
      font-size: clamp(14px, 2vw, 16px);
      color: rgba(17, 153, 250, 1);
      align-items: center;
      cursor: pointer;
    }
  }

  .tables{
    max-height: 420px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

}

@media (max-width: 400px) {
  .right-row{
    justify-content: flex-start !important;
  }
}
</style>